export default __webpack_public_path__ + "static/media/img8.2270e695.png";